import { render, staticRenderFns } from "./RejectionReasonEditPage.vue?vue&type=template&id=52fe9cc8&scoped=true&"
import script from "./RejectionReasonEditPage.vue?vue&type=script&lang=ts&"
export * from "./RejectionReasonEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./RejectionReasonEditPage.vue?vue&type=style&index=0&id=52fe9cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fe9cc8",
  null
  
)

export default component.exports